"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.error.cause.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

var _Code = _interopRequireDefault(require("./components/Code"));

var _InputNumber = _interopRequireDefault(require("@/components/common/InputNumber"));

var _message = require("@/components/dialog/message");

var Account = _interopRequireWildcard(require("@/model/user/account"));

var _security = require("@/model/user/security");

var _i18n = require("@/assets/js/i18n");

var _vuex = require("vuex");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      loginLoading: false,
      // 登录loading
      currentType: 0,
      // 当前选项
      loginData: {
        // 登录数据
        code: ""
      },
      formRules: {
        code: [{
          required: true,
          validator: this.loginValidator,
          trigger: "blur"
        }, {
          pattern: /^\d{6}$/,
          message: this.translateTitle("\u8BF7\u8F93\u5165\u6B63\u786E\u76846\u4F4D\u9A8C\u8BC1\u7801"),
          trigger: "blur"
        }]
      },
      accountInfo: {},
      authInfo: {},
      validList: [],
      mobileCounting: false,
      emailCounting: false
    };
  },
  created: function created() {
    var _this = this;

    if (this.$route.params && this.$route.params.authInfo) {
      var _this$$route$params = this.$route.params,
          accountInfo = _this$$route$params.accountInfo,
          authInfo = _this$$route$params.authInfo,
          _this$$route$params$a = _this$$route$params.authInfo,
          open_google = _this$$route$params$a.open_google,
          open_email = _this$$route$params$a.open_email,
          open_mobile = _this$$route$params$a.open_mobile;
      this.accountInfo = accountInfo;
      this.authInfo = authInfo;

      if (open_google == 1) {
        this.validList.push({
          key: "0",
          title: this.translateTitle("\u8C37\u6B4C")
        });
      }

      if (open_email == 1) {
        this.validList.push({
          key: "1",
          title: this.translateTitle("\u90AE\u7BB1")
        });
      }

      if (open_mobile == 1) {
        this.validList.push({
          key: "2",
          title: this.translateTitle("\u624B\u673A\u53F7")
        });
      }

      this.currentType = this.validList[0].key;
    } else {
      this.$router.go(-1);
      return;
    }

    document.onkeyup = function (e) {
      var keycode = document.all ? event.keyCode : e.which; // 在登录界面 且 按得键是回车键enter

      if ( // [
      //   this.routeSplicing(this.language, "login/mobile"),
      //   this.routeSplicing(this.language, "login/email")
      // ].includes(this.$route.path) &&
      ["/login/mobile", "/login/email"].includes(_this.$route.path) && keycode === 13) {
        _this.onLogin();
      }
    };
  },
  mounted: function mounted() {
    this.initFocus();
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language"
  })),
  watch: {
    loginData: {
      handler: function handler(val) {
        if (val.code.length == 6) {
          this.onLogin();
        }
      },
      deep: true
    }
  },
  methods: {
    routeSplicing: _routeSplicing.default,
    translateTitle: _i18n.translateTitle,
    initFocus: function initFocus() {
      if (this.currentType == 0) {
        this.$refs.google.onFocus();
      } else if (this.currentType == 1) {
        this.$refs.email.onFocus();
      } else if (this.currentType == 2) {
        this.$refs.mobile.onFocus();
      }
    },
    onSercuity: function onSercuity() {
      this.$router.push(this.routeSplicing(this.language, "loginSecurity"));
    },
    onMobileCode: function onMobileCode() {
      var _this2 = this;

      var tempToken = sessionStorage.getItem("topcredit_exchange_t");
      var data = {
        type: 1,
        token: tempToken
      };
      (0, _security.loginSendSmsCode)(data).then(function (rs) {
        if (rs.status == 200) {
          _this2.mobileCounting = true;
          (0, _message.showMessage)({
            message: _this2.translateTitle("\u53D1\u9001\u6210\u529F"),
            type: "success"
          });

          _this2.$refs.mobile.onFocus();
        }
      });
    },
    onEmailCode: function onEmailCode() {
      var _this3 = this;

      var tempToken = sessionStorage.getItem("topcredit_exchange_t");
      var data = {
        type: 31,
        token: tempToken
      };
      (0, _security.loginSendEmailCode)(data).then(function (rs) {
        if (rs.status == 200) {
          _this3.emailCounting = true;
          (0, _message.showMessage)({
            message: _this3.translateTitle("\u53D1\u9001\u6210\u529F"),
            type: "success"
          });

          _this3.$refs.email.onFocus();
        }
      });
    },
    // 登录校验
    loginValidator: function loginValidator(rule, value, callback) {
      var currentType = this.currentType;
      var msg = "";

      if (currentType == 0) {
        msg = this.translateTitle("\u8BF7\u8F93\u5165\u6B63\u786E\u76846\u4F4D\u9A8C\u8BC1\u7801");
      } else if (currentType == 1) {
        msg = this.translateTitle("\u8BF7\u8F93\u5165\u90AE\u7BB1\u9A8C\u8BC1\u7801");
      } else if (currentType == 2) {
        msg = this.translateTitle("\u8BF7\u8F93\u5165\u624B\u673A\u9A8C\u8BC1\u7801");
      }

      if (value === "" || !value) {
        callback(new Error(msg));
      } else {
        callback();
      }
    },

    /* 切换tab */
    onTabChange: function onTabChange(_ref) {
      var name = _ref.name;
      this.currentType = name;
      this.$refs.loginForm.resetFields(); // this.$nextTick(() => {
      //   if (name == 0) {
      //     this.$refs.google.onFocus();
      //   } else if (name == 1) {
      //     this.$refs.email.onFocus();
      //   } else if (name == 2) {
      //     this.$refs.mobile.onFocus();
      //   }
      // });
    },

    /* 获取请求参数 */
    getParams: function getParams() {
      var currentType = this.currentType;
      var params = (0, _objectSpread2.default)({}, this.loginData);
      var tempToken = sessionStorage.getItem("topcredit_exchange_t");
      params.token = tempToken;

      switch (currentType) {
        case "0":
          params.google_code = params.code;
          break;

        case "1":
          params.email_code = params.code;
          break;

        case "2":
          params.mobile_code = params.code;
          break;
      }

      delete params.code;
      return params;
    },

    /* 登录点击 */
    onLogin: function onLogin() {
      var _this4 = this;

      var currentType = this.currentType;
      this.$refs.loginForm.validate( /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var result, params;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 21;
                    break;
                  }

                  params = _this4.getParams();
                  _this4.loginLoading = true;

                  if (!(currentType == 0)) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 6;
                  return Account.googleVerifyLogin(params);

                case 6:
                  result = _context.sent;
                  _context.next = 19;
                  break;

                case 9:
                  if (!(currentType == 1)) {
                    _context.next = 15;
                    break;
                  }

                  _context.next = 12;
                  return Account.emailVerify(params);

                case 12:
                  result = _context.sent;
                  _context.next = 19;
                  break;

                case 15:
                  if (!(currentType == 2)) {
                    _context.next = 19;
                    break;
                  }

                  _context.next = 18;
                  return Account.smsVerify(params);

                case 18:
                  result = _context.sent;

                case 19:
                  _this4.handLoginSuccess(result.data, result.status, result.msg);

                  _this4.loginLoading = false;

                case 21:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },

    /* 登录成功|失败处理 */
    handLoginSuccess: function handLoginSuccess(data, status, msg) {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(status !== 200)) {
                  _context2.next = 3;
                  break;
                }

                (0, _message.showMessage)({
                  message: msg ? msg : status
                });
                return _context2.abrupt("return");

              case 3:
                (0, _message.showMessage)({
                  message: _this5.translateTitle("\u767B\u5F55\u6210\u529F"),
                  type: "success"
                }); //写入cookie, 邮箱登录 , 手机登录  注册一致

                _context2.next = 6;
                return Account.writeUserInfo(data, true);

              case 6:
                _this5.$store.dispatch("user/getUserInfo").then(function (res) {
                  var jump = _this5.$route.params.jump;

                  if (jump) {
                    //by TZ bakUrl貌似又有问题了。我这里解决的是bakUrl=true/false的问题。
                    location.href = jump;
                    return;
                  } else {
                    _this5.redirectBasedAutInfo(res.auth);
                  }
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 根据认证信息重定向
    redirectBasedAutInfo: function redirectBasedAutInfo() {
      var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var jump = this.$route.fullPath.split("redirect=")[1] || "";

      if (jump) {
        jump = decodeURIComponent(jump);
      } else {
        this.$router.push({
          path: "/"
        });
      }
    }
  },
  components: {
    InputNumber: _InputNumber.default,
    Code: _Code.default
  }
};
exports.default = _default;